<template>
    <div>
        <a-card size="small" title="OSS管理">
            <div slot="extra" class="topBtnBlock">
                <a-button type="primary" @click="handleShow">上传文件</a-button>

            </div>

            <a-modal title="上传文件" :visible="isShow" :confirm-loading="confirmLoading" width="650px" @cancel="handleCancel">
                <a-form-model layout="inline" :model="uploadParams" ref="ruleForm" :rules="rules">
                    <a-form-model-item label="所属系统" ref="syscode" prop="syscode">
                        <SysAutoComplete @onSysCodeChange="handleUploadSyscodeChange"></SysAutoComplete>
                    </a-form-model-item>

                    <a-form-model-item label="菜单路径" ref="menupath" prop="menupath">
                        <a-input style="width:200px;" v-model="uploadParams.menupath" placeholder="菜单路径" allow-clear></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="模块类型" ref="businesstype" prop="businesstype">
                        <a-input style="width:200px;" v-model="uploadParams.businesstype" placeholder="模块类型" allow-clear></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="时效天数" ref="validdate" prop="validdate">
                        <a-input-number style="width:200px;" v-model="uploadParams.validdate" placeholder="时效天数 999为永久" :min="1" :max="999">
                        </a-input-number>
                    </a-form-model-item>

                    <!--                     <a-form-model-item label="平台编码" ref="platformcode" prop="platformcode">
                        <a-input style="width:200px;" v-model="uploadParams.platformcode" placeholder="平台编码" allow-clear></a-input>
                    </a-form-model-item> -->
                    <a-form-item ref="platformcode" label="平台编码" prop="platformcode">
                        <platformSelecter :platformcode="uploadParams.platformcode" @platformChange="handlePlatformChange"></platformSelecter>
                    </a-form-item>

                    <a-form-model-item label="中文描述" ref="describe" prop="describe">
                        <a-input style="width:200px;" v-model="uploadParams.describe" placeholder="中文描述" allow-clear></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="备注信息" ref="remark" prop="remark">
                        <a-input type="textarea" style="width:508px;margin-top:10px;" v-model="uploadParams.remark" placeholder="备注信息" allow-clear></a-input>
                    </a-form-model-item>

                </a-form-model>
                <div slot="footer">
                    <a-button key="back" class="mr10" @click="handleCancel">
                        取消
                    </a-button>
                    <a-upload name="file" :multiple="true" action="https://032001.zhonglunnet.com" :headers="headers" :data="handleImportFile" @change="handleChange">
                        <a-button type="primary" :loading="isImporting" :disabled="isvalidate">
                            <a-icon type="upload" /> 上传文件
                        </a-button>
                    </a-upload>
                </div>

            </a-modal>

            <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

                <a-form-item label="环境">
                    <a-select v-model="searchP.appenv" placeholder="" style="width: 80px">
                        <a-select-option value=""> 全部 </a-select-option>
                        <a-select-option value="pre"> pre </a-select-option>
                        <a-select-option value="sit"> sit </a-select-option>
                        <a-select-option value="dev"> dev </a-select-option>
                        <a-select-option value="prod"> prod </a-select-option>
                        <a-select-option value="fat"> fat </a-select-option>
                        <a-select-option value="sim"> sim </a-select-option>
                        <a-select-option value="pet"> pet </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="系统">
                    <SysAutoComplete @onSysCodeChange="handleSearchSyscodeChange"></SysAutoComplete>
                </a-form-item>

                <!--                 <a-form-item label="平台编码">
                    <a-input v-model="searchP.platformcode" placeholder="平台编码" allow-clear></a-input>
                </a-form-item> -->
                <a-form-item label="平台编码">
                    <platformSelecter @platformChange="handleUrlPlatformChange"></platformSelecter>
                </a-form-item>

                <a-form-item label="菜单路径">
                    <a-input v-model="searchP.menupath" placeholder="菜单路径" allow-clear></a-input>
                </a-form-item>

                <a-form-item label="文件路径">
                    <a-input v-model="searchP.folderpath" placeholder="文件路径" allow-clear></a-input>
                </a-form-item>

                <a-form-item label="业务类型">
                    <a-input v-model="searchP.businesstype" placeholder="业务类型" allow-clear></a-input>
                </a-form-item>

                <a-form-item label="文件类型">
                    <a-input v-model="searchP.type" placeholder="文件类型" allow-clear></a-input>
                </a-form-item>

                <a-form-item label="时效状态">
                    <a-select v-model="searchP.validstatus" style="width: 80px">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="1">永久</a-select-option>
                        <a-select-option value="0">非永久</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="删除状态">
                    <a-select v-model="mydel" style="width: 80px">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option value="1">已删除</a-select-option>
                        <a-select-option value="0">未删除</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" @click="handleSubmit">查询</a-button>
                </a-form-item>
            </a-form>

            <a-table :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}" style="margin-top:20px;" :pagination="false" :loading="tloading" rowKey="id" @change="handleTableChange">
                <template slot="operation" slot-scope="text, record">
                    <a-button type="link" @click="handleDownload(record.folderpath)">下载</a-button>

                    <a-popconfirm title="确认删除文件?" @confirm="() => handleDelete(record)">
                        <a class="tableLink ml10" href="javascript:;">删除文件</a>
                    </a-popconfirm>
                </template>
                <template slot="domainNames" slot-scope="text">
                    <span>{{ domainName[text] }}</span>
                </template>
                <template slot="filepath" slot-scope="text,record">
                    <a-button type="link" @click="handleShowUrl(record)">{{getFileName(text)}}</a-button>
                </template>
            </a-table>
            <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

            <a-modal title="文件路径" :visible="isShowFilePath" width="850px" @cancel="handleCancelF" :footer="null">
                <a-input type="text" v-model="currentUrl" style="width:700px" />
                <a-button type="primary" class="ml20" @click="handleDownload(currentUrl)">下载</a-button>
            </a-modal>
        </a-card>

    </div>
</template>
<script>
import SysAutoComplete from '@/components/SysCodeAutoComplete'
import platformSelecter from './platformSelecter'

let pagination = {
    page: 1,
    pageSize: 10,
    total: 0,
}

const columns = [
    {
        title: '序号',
        width: 50,
        align: 'center',
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination
            return (Number(page) - 1) * Number(pageSize) + index + 1
        },
    },
    {
        title: '所属环境',
        dataIndex: 'appenv',
        align: 'center',
        width: 80,
    },
    {
        title: '所属平台',
        dataIndex: 'platformcode',
        align: 'center',
        width: 100,
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        width: 80,
    },

    {
        title: '菜单路径',
        dataIndex: 'menupath',
        align: 'center',
        width: 200,
        ellipsis: true,
    },
    {
        title: '文件名',
        dataIndex: 'folderpath',
        align: 'center',
        scopedSlots: { customRender: 'filepath' },
        ellipsis: true,
        width: 300,
    },
    {
        title: '文件类型',
        dataIndex: 'type',
        align: 'center',
        width: 120,
        ellipsis: true,
    },
    {
        title: '文件大小',
        dataIndex: 'size',
        align: 'center',
        width: 80,
    },
    {
        title: '模块类型',
        dataIndex: 'businesstype',
        align: 'center',
        width: 80,
    },
    {
        title: '中文描述',
        dataIndex: 'describes',
        align: 'center',
        width: 200,
        ellipsis: true,
    },

    {
        title: '备注信息',
        dataIndex: 'remark',
        align: 'center',
        width: 100,
        ellipsis: true,
    },
    {
        title: '时效天数',
        dataIndex: 'validdate',
        align: 'center',
        width: 80,
    },
    {
        title: '时效状态',
        dataIndex: 'validstatus',
        align: 'center',
        customRender: (text) => {
            return text == '1' ? '永久' : '非永久'
        },
        width: 80,
    },
    {
        title: '删除状态',
        dataIndex: 'del',
        align: 'center',
        customRender: (text) => {
            return text == '1' ? '已删除' : '未删除'
        },
        width: 80,
    },

    {
        title: '上传时间',
        dataIndex: 'createtime',
        align: 'center',
        width: 180,
    },
    {
        title: '有效期截止时间',
        dataIndex: 'expirdate',
        align: 'center',
        width: 180,
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 220,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            confirmLoading: false,
            form: this.$form.createForm(this),
            searchP: {
                appenv: '',
                syscode: '',
                platformcode: '',
                menupath: '',
                folderpath: '',
                businesstype: '',
                validstatus: '',
                type: '',
                del: undefined,
                starttime: '',
                endtime: '',
            },
            mydel: '',
            columns,
            tableData: [],
            tloading: false,
            pagination,
            clientWidth: 800,
            ordercoloum: 'total',
            orderstr: 'desc',
            isImporting: false,
            headers: {
                authorization: 'authorization-text',
            },
            isShow: false,
            uploadParams: {
                // 系统编码（syscode）必填
                // 菜单路径（menupath）必填
                // 模块类型（businesstype）必填
                // 中文描述(describe)  非必填
                // 平台编码(platformcode) 非必填
                // 备注信息(remark)  非必填
                // 时效天数(validdate)）必填
                syscode: '',
                menupath: '',
                businesstype: '',
                validdate: '',
                describe: '',
                platformcode: '',
                remark: '',
            },
            rules: {
                syscode: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                menupath: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                businesstype: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
                validdate: [
                    { required: true, message: ' 请输入 ', trigger: 'blur' },
                ],
            },
            isShowFilePath: false,
            currentUrl: '',
        }
    },
    computed: {
        isvalidate() {
            return (
                this.uploadParams.syscode == '' ||
                this.uploadParams.menupath == '' ||
                this.uploadParams.businesstype == '' ||
                this.uploadParams.validdate == ''
            )
        },
    },
    methods: {
        handlePlatformChange(obj) {
            this.uploadParams.platformcode = obj
        },
        handleUrlPlatformChange(obj) {
            this.searchP.platformcode = obj
        },
        handleCancelF() {
            this.isShowFilePath = false
        },
        getFileName(text) {
            if (text && text.indexOf('/') != -1) {
                let strs = text.split('/')
                return strs[strs.length - 1]
            } else {
                return text
            }
        },
        handleShowUrl(record) {
            this.currentUrl = record.folderpath
            this.isShowFilePath = true
        },
        handleDownload(folderpath) {
            window.open(folderpath)
        },
        handleShow() {
            this.isShow = true
        },
        handleCancel() {
            this.uploadParams = {
                syscode: '',
                menupath: '',
                businesstype: 'billupload',
                validdate: '',
                describe: '',
                platformcode: '',
                remark: '',
            }
            this.isShow = false
        },
        //上传文件结果处理
        handleChange(info) {
            console.log(info.file.status)
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList)
            }
            if (info.file.status === 'done') {
                //todo
                this.message.success(
                    `${info.file.name} file uploaded successfully`
                )
            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`)
            }
        },

        handleImportFile(file) {
            // let that = this;
            // http://jtfat.cnzhonglunnet.com/zl.fp.oss.manage.common.postobjectpolicy.v5/1.0.0/action?syscode=oms&businesstype=billupload

            let result = this.D.syncSelect({
                type: 'filemanager/osskey',
                params: {
                    ...this.uploadParams,
                },
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false
            }
            const data = result.data
            const { dir, policy, accessid, callback, signature } = data
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature,
            }
            const objName =
                dir + this.getUniqueCode() + this.getSuffix(file.name)
            file.objName = objName
            return {
                ...token,
                key: objName,
            }
        },
        getUniqueCode() {
            const s = []
            const hexDigits = '0123456789abcdef'
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
            }
            s[14] = '4'
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
            s[8] = s[13] = s[18] = s[23] = '-'
            return s.join('')
        },
        getSuffix(filename) {
            const pos = filename.lastIndexOf('.')
            let suffix = ''
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix
        },
        handleUploadSyscodeChange(value) {
            this.uploadParams.syscode = value
        },
        handleSearchSyscodeChange(value) {
            this.searchP.syscode = value
        },
        handleSubmit() {
            this.pagination.page = 1
            this.getAppSumData()
        },
        handleTableChange(d, v, sorter) {
            if (sorter.order) {
                this.ordercoloum = sorter.field
                this.orderstr = sorter.order.replace('end', '')
            } else {
                this.ordercoloum = ''
                this.orderstr = ''
            }

            this.getAppSumData()
        },
        handlePageChange(v) {
            this.pagination.page = v
            this.getAppSumData()
        },
        handleDelete(item) {
            let that = this
            that.$store
                .dispatch({
                    type: 'filemanager/ossdel',
                    params: {
                        id: item.id,
                        folderpath: item.folderpath,
                    },
                })
                .then((res) => {
                    if (res.status == '200') {
                        that.pagination.page = 1
                        that.getAppSumData()
                    }
                })
        },
        getAppSumData() {
            let that = this
            that.tloading = true
            if (that.mydel == '') {
                that.searchP.del = undefined
            } else {
                that.searchP.del = that.mydel
            }
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'filemanager/osslist',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        this.tableData = result.list
                        this.pagination.total = parseInt(result.totalRecords)
                        this.pagination.pageSize = parseInt(result.pageSize)
                        this.pagination.page = parseInt(result.page)
                    }
                    that.tloading = false
                })
                .catch(() => {
                    that.tloading = false
                })
        },
    },
    components: {
        SysAutoComplete,
        platformSelecter,
    },
    mounted() {
        this.handleSubmit()
    },
}
</script>
<style scoped>
</style>
